<div class="detail-page">
  <div class="container">
    <div class="d-none d-lg-block pt-3">
      <div class="back-button" [routerLink]="'/rewards/raffles'">
        <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
      </div>
    </div>
  </div>

  <div class="container d-lg-none d-block">
    <!-- Points Summary -->
    <fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'"></fgb-points-summary-bar>
  </div>

  <fgbcl-lotto-details [lottoId]="id"></fgbcl-lotto-details>
</div>
